module.exports = __webpack_public_path__ + "assets/img/seven.79a2c9c7.png";